<div class="container" cdkFocusInitial aria-modal="true">
    <div mat-dialog-title class="dialog-title">
        <h1 mat-dialog-title>Sign & Certify Report</h1>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <form id="filter_form" class="filter_form" [formGroup]="form">
            <div class="whole-line">
                <mat-form-field appearance="outline">
                <mat-label>Signing on Behalf of</mat-label>
                <mat-select formControlName="behalfOf" required>
                    @for (option of signOptions; track option) {
                    <mat-option [value]="option">{{option.name}}</mat-option>
                    }
                </mat-select>
                <mat-error>Required Field</mat-error>
                </mat-form-field>
                <!-- <mat-form-field appearance="outline" *ngIf="forests.length > 0 && data.report.authorization_status_id == 0">
                    <mat-label>{{ areaName }}</mat-label>
                    <mat-select formControlName="forest" multiple required>
                        @for (option of forests; track option) {
                        <mat-option [value]="option">{{option.name}}</mat-option>
                        }
                    </mat-select>
                    <mat-error>Required Field</mat-error>
                </mat-form-field> -->
            </div>
            <div class="whole-line">
                <mat-form-field appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="first_name" required aria-label="Fire or Complex Name">
                    <mat-error>Required Field</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="last_name" required aria-label="Fire or Complex Name">
                    <mat-error>Required Field</mat-error>
                </mat-form-field>
            </div>
            <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput formControlName="title" required aria-label="Fire or Complex Name">
                <mat-error>Required Field</mat-error>
            </mat-form-field>

            <div class="whole-line">
                <mat-checkbox formControlName="confirm">
                    <span *ngIf="this.data.signType == 'LO'">I certify that I have thoroughly reviewed the 2500-8 BAER report for {{ this.data.report.baer_name }}. 
                    The report is approved for submission to the regional office for funding recommendations.</span>
                    <span *ngIf="this.data.signType == 'RO'">I certify that I have reviewed the BAER report and the regional funding recommendations. The recommendations are authorized for funding.</span>
                    <span *ngIf="this.data.signType == 'WO'">I certify that I have reviewed the BAER report and the WO funding recommendations. The recommendations are authorized for funding.</span>
                </mat-checkbox>
            </div>
        </form>
    </mat-dialog-content>
    <div mat-dialog-actions>
        <div class="button-row">
            <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
            <button class="usa-button" [disabled]="!form.valid" (click)="sign()">Submit</button>
        </div>
    </div>
</div>